import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import {
  CaseSelectComponent,
  GkComponentsModule,
  GkMapModule,
} from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { TSRNNewRequestComponent } from './new-request/new-request.component';
import { TSRNNewRequestFormService } from './services/new-request-form/new-request-form.service';
import { TreesAndShrubsRemovalNotificationRoutingModule } from './trees-and-shrubs-removal-notification-routing.module';
import { TreesAndShrubsRemovalNotificationComponent } from './trees-and-shrubs-removal-notification.component';

@NgModule({
  declarations: [
    TreesAndShrubsRemovalNotificationComponent,
    TSRNNewRequestComponent,
  ],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    TreesAndShrubsRemovalNotificationRoutingModule,
    MatSelectModule,
    MatCheckboxModule,
    CaseSelectComponent,
  ],
  providers: [TSRNNewRequestFormService],
})
export class TreesAndShrubsRemovalNotificationModule {}
